<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="竞赛名称" class="title">
        <el-input v-model="keywordData.name_keywords[0]"></el-input>
      </el-form-item>
      <el-form-item label="竞赛状态" class="competition">
        <el-select
          v-model="keywordData.competition_status_id"
          clearable
          placeholder="竞赛状态"
          class="competition"
        >
          <el-option
            v-for="(item, index) in competitionStatusList"
            :key="index"
            :label="item.chinese_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <br />
      <el-form-item label="开始时间" class="updateTime">
        <el-date-picker
          v-model="keywordData.publish_time"
          type="daterange"
          clearable
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
import { competitionStatus_Api } from "@/apis/competition.api";
export default {
  data() {
    return {
      keywordData: {
        competition_id: null,
        name_keywords: [""],
        tags_keywords: [],
        competition_status_id: null,
        publish_time: null,
      },
      competitionStatusList: {},
      competitionTitleList: {},
    };
  },
  mounted() {
    this.searchCompetitionStatus();
  },
  methods: {
    searchCompetitionStatus() {
      competitionStatus_Api().then((res) => {
        this.competitionStatusList = res.data;
        console.log(this.competitionStatusList);
      });
    },

    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-range-editor.el-input__inner {
  width: 490px;
}
.pc-search {
  @include table-search;
  .competition {
    width: 400px;
  }
  .title {
    width: 600px;
  }
  .updateTime {
    width: 600px;
  }
  .is-wupen {
    width: 200px;
    margin-right: 110px;
  }
  .tag {
    width: 300px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .status {
    width: 200px;
  }
  .keyword {
    width: 400px;
    height: 40px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/NewCompetitionSearch.vue